import _ from 'lodash';
//import moment from 'moment';

import Actionbar from './Actionbar';
import StatusChip from 'components/StatusChip';
import { operationTypes } from 'constants/operationTypes';

function generateColumns(handlers) {
  const genericColumnProps = {
    align: 'center',
    editable: false,
    headerAlign: 'center',
    resizable: false,
    filterable: false,
  };

  const baseColumns = [
    {
      field: 'id',
      headerName: '#',
      flex: 0.5,
      renderCell: (row) => {
        return parseInt(row.id);
      },
      description: 'Id de usuario',
      type: 'number',
    },
    {
      field: 'person_name',
      headerName: 'Nombre',
      flex: 0.8,
      description: 'Nombre del usuario',
    },
    {
      field: 'person_lastname',
      headerName: 'Apellido',
      flex: 0.8,
      description: 'Apellido del usuario',
    },
    {
      field: 'person_tributary_key',
      headerName: 'CUIL',
      type: 'number',
      flex: 0.8,
      description: 'Nro. de documento de usuario',
    },
    {
      field: 'contract_date',
      headerName: 'Fecha Operación',
      flex: 1,
      description: 'Fecha de alta del usuario',
      //renderCell: ({ row: { date } }) => moment(date).format('DD/MM/YYYY'),
    },

    {
      field: 'batch_number',
      headerName: 'Nro. Lote',
      type: 'number',
      flex: 0.7,
      description: 'Nro. de lote correspondiente al alta del usuario',
    },
    {
      field: 'batch_description',
      headerName: 'Descr. Lote',
      flex: 1,
      description: 'Descripción del lote al cual pertenece el usuario',
      filterable: false,
    },
    {
      field: 'id_ob_operation_status',
      headerName: 'Estado',
      renderCell: ({ row: { id_ob_operation_status: opStatus } }) => (
        <StatusChip status={opStatus} />
      ),
      flex: 0.8,
      align: 'left',
      description: 'Estado de la operación correspondiente al usuario',
    },
    {
      field: 'id_type',
      headerName: 'Tipo de Operación',
      flex: 0.8,
      description: 'Tipo de operación',
      renderCell: (row) => operationTypes[row.value],
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      flex: 1.5,
      renderCell: ({ row }) => {
        return <Actionbar handlers={{ ...handlers }} id={row.id} row={row} />;
      },
      description: 'Operaciones para cada usuario',
      disableColumnMenu: true,
    },
  ];

  const fullColumns = _.map(baseColumns, (column) => {
    return _.merge({}, genericColumnProps, column);
  });

  return fullColumns;
}

export default generateColumns;
